// Utility to fix image and cross-link paths in markdown for Photo Kiosk Backend docs
export default function fixImagePaths(markdown) {
  // Convert <a href="..."><img src="..." ...></a> to [![alt](img-url)](a-url)
  let fixed = markdown.replace(
    /<a[^>]+href=["'](images\/[\w\-./]+)["'][^>]*>\s*<img([^>]+)src=["'](images\/[\w\-./]+)["']([^>]*)>\s*<\/a>/g,
    (match, href, pre, src, post) => {
      const altMatch = /alt=["']([^"']*)["']/.exec(match);
      const alt = altMatch ? altMatch[1] : '';
      return `[![${alt}](/assets/images/photo-kiosk-backend/${src.replace('images/', '')})](/assets/images/photo-kiosk-backend/${href.replace('images/', '')})`;
    }
  );
  // Convert standalone <img ...> tags to Markdown image syntax
  fixed = fixed.replace(
    /<img([^>]+)src=["'](images\/[\w\-./]+)["']([^>]*)>/g,
    (match, pre, path, post) => {
      const altMatch = /alt=["']([^"']*)["']/.exec(match);
      const alt = altMatch ? altMatch[1] : '';
      return `![${alt}](/assets/images/photo-kiosk-backend/${path.replace('images/', '')})`;
    }
  );
  // Fix Markdown image syntax
  fixed = fixed.replace(/!\[(.*?)\]\((images\/[\w\-./]+)\)/g, (match, alt, path) => {
    return `![${alt}](/assets/images/photo-kiosk-backend/${path.replace('images/', '')})`;
  });
  // Fix HTML <a href="images/...">
  fixed = fixed.replace(/<a([^>]+)href=['"](images\/[\w\-./]+)['"]/g, (match, pre, path) => {
    return `<a${pre}href="/assets/images/photo-kiosk-backend/${path.replace('images/', '')}"`;
  });
  // Fix cross-links to .md files (support ../, ./, or direct file name)
  fixed = fixed.replace(
    /\[([^\]]+)\]\(((\.\.\/|\.\/)?(USER_GUIDE|API|SECURITY-RECOMMENDATIONS|SUPPORT|README)\.md)\)/g,
    (match, text, _full, _prefix, fileBase) => {
      const map = {
        USER_GUIDE: '/products/photo-kiosk-backend/user-guide',
        API: '/products/photo-kiosk-backend/api-reference',
        'SECURITY-RECOMMENDATIONS': '/products/photo-kiosk-backend/security',
        SUPPORT: '/products/photo-kiosk-backend/support',
        README: '/products/photo-kiosk-backend/user-guide',
      };
      return `[${text}](${map[fileBase] || '#'})`;
    }
  );
  return fixed;
}
